module.exports = __webpack_public_path__ + "img/tr.219394fc.svg";